import axios from "axios";
import qs from 'qs';
import router from '../router'
import {showMessage} from "./notice";
import {Loading} from "element-ui";
import {setStore} from "./storage";

const request = axios.create({
  baseURL: "/sms/repo",
  timeout: 30000
})

/**
 * config.target：响应数据的dom容器，在请求完成前，用loading遮罩
 */
request.interceptors.request.use(
  config => {
    if (config.target) {
      config.loading = Loading.service({target: config.target, customClass: "sms-loading"});
    }
    if (config.loadingTargets && config.loadingTargets.length) {
      config.loadingList = config.loadingTargets.map(item => {
        return Loading.service({target: item, customClass: "sms-loading"});
      })
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
)
/**
 * 1.200：
 * success为true：请求成功
 * success为false：请求失败，返回的均是可读信息（根据此信息可以快速定位）
 *
 * 2.401：
 * errorType为NOT_LOGIN_LOCAL：未进行本地登录，跳转到本地登录界面
 * errorType为NOT_LOGIN_CAS：CAS校验不通过，跳转到CAS登录界面
 *
 * 3.其他：（例如400，404，500，502，504等）
 * 均显示为未知错误
 */
request.interceptors.response.use(
  response => {
    if (response.config.loading) {
      response.config.loading.close()
    }
    if (response.config.loadingList) {
      response.config.loadingList.forEach(loading => {
        loading.close();
      })
    }
    if (response.data.success) {
      return Promise.resolve(response.data);
    } else {
      showMessage("请求失败，异常信息：" + response.data.message, "error")
      return Promise.reject()
    }
  },
  error => {
    if (error.config.loading) {
      error.config.loading.close()
    }
    if (error.config.loadingList) {
      error.config.loadingList.forEach(loading => {
        loading.close();
      })
    }
    let status = error.response.status;
    let data = error.response.data;

    if (status === 401) {
      if (data.errorType) {
        switch (data.errorType) {
          case "NOT_LOGIN_LOCAL":
            router.replace({
              name: "localLogin",
              params: {"referer": data.referer},
            })
            return Promise.reject()
          case "NOT_LOGIN_CAS":
            //将当前的location记录下来，等到登录成功后，再跳转回来
            setStore("casReferer", location.origin + location.pathname);
            location.href = process.env.smsRepoCasLoginUrl
            break;
        }
      } else {
        return Promise.reject(error)
      }
    } else {
      showMessage("未知错误，请联系管理员", "error")
      return Promise.reject(error)
    }
  }
)

/**
 * 全局get请求
 * @param {*} url
 * @param {*} params
 * @param target 在请求完成前，显示loading动画的dom元素
 */
export const getRequest = (url, params, target) => {
  let config = {
    method: 'get',
    url,
    params,
    paramsSerializer(params) {
      return qs.stringify(params, {arrayFormat: 'repeat'})
    },
  };
  if (Array.isArray(target)) {
    config.loadingTargets = target;
  } else {
    config.target = target;
  }
  return request(config);
}
/**
 * 全局post请求
 * @param {*} url
 * @param {*} data body参数
 * @param params 查询参数
 * @param target 在请求完成前，显示loading动画的dom元素
 */
export const postRequest = (url, data, params, target) => {
  let config = {
    method: 'post',
    url,
    params,
    data: data,
  };
  if (Array.isArray(target)) {
    config.loadingTargets = target;
  } else {
    config.target = target;
  }
  return request(config);
}



// WEBPACK FOOTER //
// ./src/utils/request.js